import { useState, useContext, useEffect } from 'react';

import { ExperienceContext } from '@thd-nucleus/experience-context';

import { postClearCallbackVerification } from '../utils/api';

export const useClearCallbackVerification = ({ code, state, error: callbackError, errorDescription }) => {
  const [data, setData] = useState({});
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [isExecutable, setIsExecutable] = useState(true);

  const ctx = useContext(ExperienceContext);
  const { hosts } = ctx;
  const { apionline } = hosts || {};

  const executeRequest = async () => {
    if (isExecutable) {
      setLoading(true);
      setIsExecutable(false);
      try {
        const result = await postClearCallbackVerification({
          host: apionline, code, state, error: callbackError, errorDescription
        });
        setData(result);
        setError('');
      } catch (err) {
        setError(err.message || 'Unexpected Error');
        setData({});
        setIsExecutable(true);
      } finally {
        setLoading(false);
      }
    } else {
      setData({ ...data });
    }
  };

  useEffect(() => {
    executeRequest()
  }, [code, state, callbackError, errorDescription]);

  return {
    data,
    error,
    loading,
    executeRequest
  };
};
